import axiosInstance from "./config";
import { IBannerCreate } from "views/admin/banner/types/banners.interface";

const basePath = `/induk-app/banners`;

export const getBanners = (page?: number, limit?: number, search?: string) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      limit,
      search,
    },
  });
};

export const addBanner = (payload: IBannerCreate) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value as string);
  });

  return axiosInstance.post(`${basePath}/create`, formData);
};

export const getBanner = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateBanner = (slug: string, coupon: Partial<IBannerCreate>) => {
  const formData = new FormData();
  Object.entries(coupon).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value as string);
  });

  return axiosInstance.patch(`${basePath}/${slug}/update`, formData);
};

export const deleteBanner = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/remove`);
};
